<script lang="ts" setup>
import { onMounted, computed } from 'vue';
import { useAuthStore } from '@/store';

const authStore = useAuthStore();

const isLoading = computed(() => authStore.loading);

onMounted(() => init());

const init = async () => {
  if (authStore.isImpersonating && !authStore.user) {
    await authStore.getAuthUserProfile();
  }
};

const onLeave = () => authStore.leaveImpersonate();
</script>

<template>
  <div v-if="authStore.isImpersonating">
    <Skeleton v-if="isLoading" width="8rem" height="2rem" class="ml-2" />
    <div v-else class="flex justify-content-between h-2rem bg-purple-light border-round ml-2 pl-2 align-items-center">
      <div class="flex justify-content-around align-items-center justify-content-center text-sm text-color-purple-dark">
        <Icon class="md:hidden text-base text-color-purple" library="material-icons-round" name="fingerprint" />
        <div class="hidden md:inline-flex ml-1">Impersonating</div>
        <div class="font-bold ml-1 white-space-nowrap">{{ authStore.displayName }}</div>
        <div class="hidden md:inline-flex ml-1">({{ authStore.typeTitle }})</div>
      </div>
      <Icon name="close" class="text-color-purple text-sm p-2 cursor-pointer" @click="onLeave" />
    </div>
  </div>
</template>
